import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {PropType} from "vue";
import {TableAOptions, VATableRecord} from "../extends/typing";


export default /*@__PURE__*/_defineComponent({
  __name: 'TableA',
  props: {
  value: {
    type: String,
    required: true
  },
  options: {
    type: Object as PropType<TableAOptions>,
    default: () =>{
      return {}
    }
  },
  record: {
    type: Object as PropType<VATableRecord>,
    default: () => {
      return {}
    }
  }
},
  setup(__props) {

const props = __props

const onClick = () =>{
  if (props.options.click){
    props.options.click(props.record)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", { onClick: onClick }, _toDisplayString(__props.value), 1))
}
}

})